export const Portfolio = () => {
  return (
    <svg viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.7629 9.16561C10.5721 9.61694 10.2736 10.0146 9.89352 10.324C9.51346 10.6333 9.06341 10.8448 8.58273 10.94C8.10205 11.0352 7.60536 11.0112 7.13609 10.8701C6.90186 10.7997 6.67801 10.7011 6.46921 10.5772M6.80006 5.24774C6.35094 5.44373 5.95667 5.74675 5.65171 6.13032C5.34676 6.51389 5.14041 6.96632 5.0507 7.44806C4.96099 7.9298 4.99066 8.42618 5.13711 8.8938C5.21144 9.13116 5.31472 9.35745 5.44398 9.5678"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6999 7.99865C10.8656 7.99865 11.0015 7.864 10.9849 7.69914C10.9557 7.40793 10.884 7.12202 10.7715 6.85063C10.6208 6.48667 10.3998 6.15596 10.1212 5.8774C9.84268 5.59883 9.51197 5.37786 9.14801 5.2271C8.87662 5.11469 8.59071 5.04296 8.2995 5.01374C8.13465 4.9972 8 5.13306 8 5.29875V7.69864C8 7.86433 8.13431 7.99865 8.3 7.99865H10.6999Z"
        fill="currentColor"
      />
      <path
        d="M0.5 1C0.5 0.723858 0.723858 0.5 1 0.5H5.58579C5.71839 0.5 5.84557 0.552678 5.93934 0.646447L7.35355 2.06066C7.63486 2.34197 8.01639 2.5 8.41421 2.5H15C15.2761 2.5 15.5 2.72386 15.5 3V13C15.5 13.2761 15.2761 13.5 15 13.5H1C0.723858 13.5 0.5 13.2761 0.5 13V1Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  )
}
